export const formatDate = (utcString: string) => {
    const isDateOnly = /^\d{4}-\d{2}-\d{2}$/.test(utcString);
    const date = isDateOnly
        ? new Date(utcString + 'T00:00:00') // Treat as local date
        : new Date(utcString);

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    if (isDateOnly) {
        return `${day}-${month}-${year}`;
    }

    const time = date.toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
    });

    return `${day}-${month}-${year}, ${time}`;
};
